import { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../../Context/ConfigContext";
import axios from "axios";
import { Link, NavLink } from "react-router-dom";
import { OverlayLoader } from "../../../Components/Shimmers";
import "./OilSaleParts.css"
import { CartsContext } from "../../../Context/CartsContext";
import { toast } from "react-toastify";
import { AddToCartNotifier } from "../../../Components/CartComponents";
import { useTranslation } from "react-i18next";
import { axiosGet } from "../../../Apis/axiosMethods";

const OilSaleParts = () => {

    const {
        apiB2BURL,
        apiHeaderJson,
        business_type,
        apiURL,
        setIsCartDropdownOpen
    } = useContext(ConfigContext);
    const { AddToCart, GetCartItemQty } = useContext(CartsContext);

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);


    const { t } = useTranslation();


    const fetchProducts = async () => {
        try {

            setLoading(true);

            const response = await axiosGet(`/Products/GetProducts`,
                { business_type }
            );

            if (response?.data?.success) {
                setProducts(response.data.data);
            }

        } catch (error) {
            console.log("error", error);
        } finally {
            setLoading(false);
        }
    };

    const handleAddToCart = async (item, url) => {

        const prev_qty = await GetCartItemQty(item.stock_number);
        const partImg = url || `${apiURL}/public/placeholder_category.jpeg`;

        if (item?.stock_available_qty >= Number(1) + prev_qty) {
            const sale_type = "oil";
            await AddToCart(item, 1, partImg, partImg, sale_type);
            setIsCartDropdownOpen(true);
            window.scrollTo(0, 0);
        } else {

            toast.success(
                <AddToCartNotifier
                    item_name={t('sorry_we_have_only', { value: 1 })}
                    item_img={''}
                />
            );

        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const scrollToProducts = () => {
        document.getElementById("products-section").scrollIntoView({
            behavior: "smooth"
        });
    };

    const handleScrollTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <>
            {
                loading ? <div style={{ height: "70vh" }}>
                    <OverlayLoader />
                </div>
                    :
                    <div className="container">

                        <nav aria-label="breadcrumb" className="breadcrumb-nav my-3">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <NavLink to="/">
                                        <i className="icon-home" />
                                    </NavLink>
                                </li>
                                <li className="breadcrumb-item active">Oil & Lubes</li>
                            </ol>
                        </nav>

                        <div className="row">
                            <div className="col-md-12 mb-4">
                                <div
                                    style={{
                                        overflow: "hidden"
                                    }}
                                >
                                    <video
                                        src="/assets/images/oil/oil-banner-video-2.mp4"
                                        autoPlay
                                        loop
                                        muted
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block"
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-md-12" id="products-section">
                                <h3 style={{
                                    fontWeight: "700",
                                    color: "#132531",
                                    textAlign: "center"
                                }}>
                                    Oil & Lubes
                                </h3>
                                <hr style={{ width: "60px", border: "2px solid #cc000b", marginTop: "5px" }} />
                            </div>

                            {[...new Map(products.map(item => [item.stock_number, item])).values()].map((item, index) => (

                                <div
                                    key={index}
                                    className="col-md-2-4 mb-4"
                                >

                                    <div
                                        className="h-100 d-flex flex-column justify-content-between shadow-sm rounded border position-relative"
                                        style={{ cursor: "pointer" }}
                                    >

                                        <Link to={`/Spare-Parts/Oil-Details/${item?.product_number}/${item?.product_id}`}>

                                            <div
                                                style={{
                                                    height: '200px',
                                                    backgroundColor: '#fff',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '10px',
                                                }}
                                            >

                                                <img
                                                    src={
                                                        item?.product_image_url ||
                                                        `${apiURL}/public/placeholder_category.jpeg`
                                                    }
                                                    alt={item?.product_name}
                                                    style={{
                                                        maxHeight: "100%",
                                                        maxWidth: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />

                                            </div>

                                        </Link>

                                        <div className="product-details p-3 d-flex flex-column flex-grow-1">

                                            {/* Product Info */}

                                            <div style={{ minHeight: "50px" }}>

                                                <Link to={`/Spare-Parts/Oil-Details/${item?.product_number}/${item?.product_id}`}
                                                    onClick={handleScrollTop}
                                                >
                                                    <h5 className="mb-0" style={{ color: "#132531", fontWeight: "bold" }}>
                                                        {item?.product_name}
                                                    </h5>
                                                </Link>

                                                <Link to={`/Spare-Parts/Oil-Details/${item?.product_number}/${item?.product_id}`}
                                                    onClick={handleScrollTop}
                                                >
                                                    <p className="text-muted small mb-0">
                                                        Article Number : <b>{item?.product_number}</b>
                                                    </p>
                                                </Link>

                                                {/* <p className="text-muted small mb-2">
                                                    Brand : {item?.product_brand_name}
                                                </p> */}

                                            </div>

                                            <div className="mb-1">
                                                {
                                                    (item?.VD_QTY > 0 && business_type === 1 ? Number(item?.VD_BG_PRICE) : Number(item?.VD_BB_PRICE) > 0) ?
                                                        <>
                                                            <h4 className="mb-0">{item?.display_price}</h4>
                                                            <small>
                                                                <span className='text-success' style={{ fontWeight: "bold" }}>
                                                                    Offer price excl. 5.0% VAT, </span>
                                                                <span style={{ fontWeight: "bold" }} className='text-danger'>Free delivery</span>
                                                            </small>
                                                        </>
                                                        :
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <h4 className="mb-0">Out Of Stock</h4>
                                                            <small></small>
                                                        </div>
                                                }

                                            </div>

                                            {/* Price + Button */}

                                            <div className="d-flex justify-content-between align-items-center mt-auto">

                                                {(item?.VD_QTY > 0 && business_type === 1 ? Number(item?.VD_BG_PRICE) : Number(item?.VD_BB_PRICE) > 0) ? (

                                                    <button
                                                        className="btn btn-dark add-cart text-light w-100"
                                                        onClick={() => handleAddToCart(item, item?.product_image_url)}
                                                    >
                                                        <i className="fas fa-shopping-cart mr-2"></i> Buy Now
                                                    </button>

                                                ) : (

                                                    <Link
                                                        to={`/Spare-Parts/Oil-Details/${item?.product_number}/${item?.product_id}`}
                                                        className="btn btn-cart-blue text-light w-100"
                                                        onClick={handleScrollTop}
                                                    >
                                                        <i className="fas fa-eye mr-2"></i> View Details
                                                    </Link>

                                                )}

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div >
            }
        </>

    );
};

export default OilSaleParts;